import React from "react"
import * as s from "./about-large.module.less";
import * as landingPageStyle from "../landing-page.module.less"
import Pane from "../../pane/pane";
import PaneTitle from "../../pane/pane-title/pane-title";
import Button from "../../button";
import AboutBox from "./about-box";
import imageMarcel from "../../../media/team/mmichelfelder.png"
import imageStefan from "../../../media/team/swintergerst.png"
import imageLena from "../../../media/team/lwiedmann.png"
import cn from "classnames";

// Example placeholder team member data
const teamMembers = [
  {
    name: "Marcel Michelfelder",
    role: "CEO",
    roleDescription: "Chief Executive Officer",
    img: imageMarcel,
    description: "..formt Systeme, die Ideen greifbar machen und Prozesse intelligent verbinden. Seine Arbeiten vereinen strategisches Denken, technische Tiefe und ein feines Gespür für Struktur und Klarheit."
  },
  {
    name: "Stefan Wintergerst",
    role: "CTO",
    roleDescription: "Chief Technology Officer",
    img: imageStefan,
    description: "..denkt in Systemen, baut Werkzeuge mit Tiefe und Präzision. Sein Schaffen verbindet technische Klarheit mit einem Gespür für Struktur, Skalierbarkeit und den stillen Charme eleganter Lösungen."
  },
  {
    name: "Lena Wiedmann",
    role: "CDO",
    roleDescription: "Chief Design Officer",
    img: imageLena,
    description: "..bewegt sich zwischen Design und Technologie und gestaltet interaktive Systeme mit Klarheit und Intention. Ihre Projekte spiegeln Neugier für Kollaboration, intelligente Werkzeuge und digitale Ästhetik wider."
  }
];

const AboutLarge = ({
  heading,
  btn,
  backgroundColor
}) => {
  return (
      <Pane
        noPadding
        bgColor={backgroundColor ?? '#f9f9f9'}
      >
        <div className={s.about}>
          <div className={cn(landingPageStyle.container, s.container)}>
            <div className={s.textBox}>
              <PaneTitle title={heading}/>
              <p className={s.description}>
                Wir sind ein Team von erfahrenen Entwicklern und Designern, spezialisiert auf die schnelle Umsetzung von
                digitalen Produkten.
                Wir helfen Startups und etablierten Unternehmen, ihre Ideen durch praxisnahe Prototypen zu validieren
                und erfolgreich auf den Markt zu bringen.
              </p>
              <Button
                  label={btn.text.toUpperCase()}
                  href={btn.href}
                  size={"xs"}
                  className={cn(s.btn, btn.shouldBreak && s.btnBreak)}
              />
            </div>
            <div className={s.teamSection}>
              {/*<h2>Unser Kernteam</h2>*/}
              <div className={s.teamGrid}>
                {teamMembers.map((member, index) => (
                    <AboutBox
                        name={member.name}
                        img={member.img}
                        role={member.role}
                        roleDescription={member.roleDescription}
                        description={member.description}
                        imageAtBottom={index % 2 !== 0}
                    />
                ))}
              </div>
            </div>
          </div>
        </div>
      </Pane>
  );
}
export default AboutLarge
